module.exports = __webpack_public_path__ + "img/invoice-excel-alb.599ea7ed.svg";